export default function MarquesMotorisation() {
  return (
    <section className="bg-white py-14 md:py-20">
      <div className="max-w-4xl mx-auto px-4 md:px-8">
        <h2 className="text-2xl md:text-3xl font-bold text-brand-blue mb-6">
          Toutes marques de motorisation
        </h2>
        <p className="text-brand-text leading-relaxed mb-5">
          Notre service de réparation de volets roulants électriques couvre l'ensemble des marques du marché. Nous intervenons sur les moteurs Somfy, leader incontesté avec ses protocoles RTS et IO-Homecontrol, ainsi que sur les systèmes Nice, Bubendorff, Profalux, Faac, Came, Simu, Becker et d'autres fabricants européens. Chaque marque possède ses spécificités techniques : protocole radio propriétaire, alimentation solaire, fils conducteurs intégrés, ou moteurs intégrés au tablier. Notre stock de pièces détachées et nos outils de diagnostic nous permettent de réparer la plupart des pannes en une seule visite.
        </p>
        <p className="text-brand-text leading-relaxed mb-8">
          Pour les installations domotiques, nous maîtrisons également l'intégration des volets roulants dans les systèmes de maison connectée. Nous diagnostiquons les problèmes de communication entre les volets et les box domotiques (Somfy TaHoma, Somfy Connexoon, ou autres solutions universelles). Si un module de commande est défectueux, nous le remplaçons par une pièce compatible et reconfigurons l'ensemble des scénarios programmés. Notre polyvalence multi-marques et notre expertise domotique garantissent une réparation rapide et durable, quelle que soit la technologie équipant vos volets.
        </p>

        <h3 className="text-xl font-semibold text-brand-blue mb-4">
          Marques et technologies couvertes
        </h3>
        <ul className="space-y-3">
          {[
            "Somfy : réparation et reprogrammation RTS, IO-Homecontrol et systèmes filaires",
            "Nice : diagnostic et réparation des moteurs pour volets lourds et grandes baies",
            "Bubendorff : intervention sur moteurs intégrés et batteries solaires",
            "Profalux : réparation des systèmes avec fils conducteurs WireFree et FreeVox",
            "Faac, Came, Simu, Becker : réparation et remplacement des moteurs et commandes",
            "Domotique : réparation des modules de commande et réintégration dans les systèmes connectés",
          ].map((item) => (
            <li key={item} className="flex items-start gap-3">
              <span className="w-5 h-5 flex items-center justify-center text-brand-cyan mt-0.5 flex-shrink-0">
                <i className="ri-checkbox-circle-line text-lg"></i>
              </span>
              <span className="text-brand-text text-sm md:text-base">{item}</span>
            </li>
          ))}
        </ul>
      </div>
    </section>
  );
}